import cn from 'classnames'
import Image from 'next/image'
import { FC, ReactElement } from 'react'

import Calculator from 'components/ui/calculator'

import { ICoinPageCurrency } from 'config/coin-pages-list'

import PartnerChangenow from 'pages/home/components/main-block/icons/partner-changenow.svg'

import PartnerGuarda from './icons/partner-guarda.svg'
import TrustPilot from './icons/trustpilot-logo.svg'

import styles from './styles.module.scss'
import { useTranslation } from 'utils/use-translation'

export const MainBlock: FC<{
  currenciesCount: number
  isSupported: boolean
  description: string
  pageCurrency: ICoinPageCurrency
  h1?: ReactElement
}> = ({ currenciesCount, isSupported, pageCurrency, h1, description }) => {
  const { t, locale, replacePlaceholders } = useTranslation()

  return (
    <div className={styles.background}>
      <div className={cn(styles.mainBlock, { [styles.mainBlockNoPad]: !isSupported })}>
        <div className={styles.mainBlockBackground}>
          <img
            width={1200}
            height={1200}
            src={
              pageCurrency.background && pageCurrency.background.data
                ? `https://cms-staging.coinrabbit.io${pageCurrency.background.data.attributes.url}`
                : `/assets/coin-pages/backgrounds/${pageCurrency.code.toLowerCase()}.svg`
            }
            alt={t('coin_page_icon')}
          />
        </div>
        <div className={cn('container', styles.mainBlockWrapper)}>
          <div className={styles.greeting} data-lang={locale}>
            <h1 className={styles.titlePage}>
              {h1 || (
                <span dangerouslySetInnerHTML={{ __html: 
                  replacePlaceholders(t('get_instant_coint_loan_default_title'), { 
                    styleSpan: styles.titlePage_Span,
                    styleFirstWord: styles.firstWord,
                    name: pageCurrency.name, 
                    code: pageCurrency?.altName || pageCurrency.code.toUpperCase() }) }}>
                </span>
              )}
            </h1>
          </div>
          <div className={styles.additionalInfo}>
            <div className={styles.subtitleText}>
              {t(description).trim() ? t(description) : (
                <>
                  <span>
                    {t('borrow_against')} {pageCurrency?.altName || pageCurrency.code.toUpperCase()} {t('for_unlimited_term')}
                    {', '}
                  </span>
                  <span>{t('crypto_without_selling')}</span>
                </>
              )}
            </div>
            <div className={styles.advantages}>
              <div className={styles.advantagesItem}>
                <p className={styles.advantagesMain}>{t('safe')}</p>
                <p className={styles.advantagesText}>
                  <span className={styles.nowrap}>{t('top_tier_security')},</span>
                  <span>{t('cold_wallet_storage')}</span>
                </p>
              </div>
              <div className={styles.advantagesItem}>
                <p className={styles.advantagesMain}>{t('easy')}</p>
                <p className={styles.advantagesText}>
                  <span>{t('no_credit_check')}</span>
                </p>
              </div>
              <div className={styles.advantagesItem}>
                <p className={styles.advantagesMain}>{t('start')}</p>
                <p className={styles.advantagesText}>{t('from')} $100</p>
              </div>
              <div className={styles.advantagesItem}>
                <p className={styles.advantagesMain}>{currenciesCount}+</p>
                <p className={styles.advantagesText}>{t('currencies')}</p>
              </div>
              <div className={styles.partnersBoxInner}>
                <span className={cn(styles.partnersBoxTitle, styles.desktopOnly)}>{t('our_partners')}:</span>
                <div className={styles.partnersBoxItems}>
                  <a
                    href="https://changenow.io/"
                    rel="noopener noreferrer nofollow"
                    target="_blank"
                    className={styles.partner}
                  >
                    <img src={PartnerChangenow} alt="changeNow" width={58} height={33} />
                  </a>
                  <a
                    href="https://guarda.com/"
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className={styles.partner}
                  >
                    <img src={PartnerGuarda} alt="Guarda Wallet" width={65} height={50} />
                  </a>
                </div>
              </div>
              <div className={styles.partnersBoxInner}>
                <span className={cn(styles.partnersBoxTitle, styles.desktopOnly)}>{t('rated_excellent')}:</span>
                <div className={styles.partnersBoxItems}>
                  <a
                    href="https://www.trustpilot.com/review/coinrabbit.io"
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className={styles.partner}
                  >
                    <Image src={TrustPilot} alt="TrustPilot" width={80} height={50} layout={'fixed'} priority={true} />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.calculator}>
            <Calculator pageCurrency={pageCurrency} />
          </div>
        </div>
      </div>
    </div>
  )
}
